theme.ScrollingText = (function() {
  function Scrolling(e) {
    function initializeTicker(scrollingTextWrapper) {
      var list = scrollingTextWrapper.querySelector("ul.text__list");
      var clonedList = list.cloneNode(true);
      var listItems = list.querySelectorAll("li");
      var listWidth = 10;
  
      listItems.forEach(function(item) {
        listWidth += item.offsetWidth + parseInt(window.getComputedStyle(item).marginLeft) + parseInt(window.getComputedStyle(item).marginRight);
      });
  
      var endPos = scrollingTextWrapper.offsetWidth - listWidth;
  
      list.style.width = listWidth + "px";
      clonedList.style.width = listWidth + "px";
      clonedList.classList.add("cloned");
      scrollingTextWrapper.appendChild(clonedList);
  
      // Animation variables
      var time = 40 * 1000; // 40 seconds converted to milliseconds
      var start = null;
      var isPaused = false;
      var shift = 0;
  
      function animate(timestamp) {
        if (isPaused) return;
        if (!start) start = timestamp;
        var progress = timestamp - start;
  
        // Calculate the position
        shift = (progress / time) * listWidth;
        if (shift > listWidth) {
          shift = shift % listWidth;
          start = timestamp;
        }
  
        list.style.transform = `translateX(${-shift}px)`;
        clonedList.style.transform = `translateX(${listWidth - shift}px)`;
  
        requestAnimationFrame(animate);
      }
  
      // Start the animation
      requestAnimationFrame(animate);
  
      // Pause/Play
      scrollingTextWrapper.addEventListener("mouseenter", function() {
        isPaused = true;
      });
  
      scrollingTextWrapper.addEventListener("mouseleave", function() {
        isPaused = false;
        start = performance.now() - (shift / listWidth) * time; // Adjust start time
        requestAnimationFrame(animate);
      });
    }
  
    // Initialize all tickers
    document.querySelectorAll(".scrolling__text__wrapper").forEach(function(scrollingTextWrapper) {
      initializeTicker(scrollingTextWrapper);
    });
  }
  return Scrolling;
})();